import Vue from "vue";
import Vue2SmoothScroll from "vue2-smooth-scroll";

Vue.use(Vue2SmoothScroll, {
   offset: -150
});